import React, { useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import { ButtonComp } from 'atoms/Buttons';
import { useHistory } from 'react-router-dom';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { redirectToHomePage } from 'common/utilities/utils';

const ThankYouPage = props => {
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const gotToHome = () => {
    redirectToHomePage({ history });
  };
  return (
    <div className='thankyou-success-container'>
      <div className='thankyou-confirm-icon'>
        <ReactSVG src={IMAGE_PATH.ConfirmedSignOut} />
      </div>
      <div className='main-text-thankyou'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.THANK_YOU)}</div>
      <div className='ty-received-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.THANK_COMMENT_MSG)}</div>
      <div className='thankyou-confirm-button'>
        <ButtonComp data-testid='take-me-homeid' className='take-me-home-thankyou' onClick={gotToHome}>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY.TAKE_ME_HOME)}
        </ButtonComp>
      </div>
    </div>
  );
};

export default ThankYouPage;
